import React, { Component } from "react";
import { Modal, Row, Col, Button, Form } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;

export default class JustificativaModalForm extends Component {
  state = {
    texto: ''
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionadoJustif !== propsAnterior.registroSelecionadoJustif) {
      this.setState({
        visualizar: this.props.registroSelecionadoJustif.visualizar,
        texto: '',
      }, () => {

      });
    }
  }

  onOK = () => {
    this.props.onSalvarJustifClick(this.props.registroSelecionadoJustif, this.state.texto);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };



  render() {
    const { texto } = this.state;
    const { onCancelarJustifClick, carregando, visivel } = this.props;

    return (
      <Modal
        title={"Justificativa"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarJustifClick}
        footer={null}
        width={"30%"}
        style={{ top: 10 }}
        centered
      // maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', borderRadius: 8 }}
      // style={{ backgroundColor: 'transparent' }}
      // bodyStyle={{ backgroundColor: 'transparent', backgroundColor: Colors.dividerDark, borderRadius: 8 }}
      >
        <Row>
          <Col xs={24} className="camposEspacoDireita">
            <span>Justificativa</span>
            <InputForm
              id="texto"
              ref="texto"
              maxLength={100}
              onChange={this.onChange}
              value={texto}
            />
          </Col>
        </Row>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  OK
                </Button>
                <Button
                  htmlType="button"
                  onClick={onCancelarJustifClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JustificativaModalForm.js